import React from "react"
import { Typography, withStyles } from "@material-ui/core"

const style = (theme) => ({
    padding: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
})

const headerMd = ({ variant, classes, insidePaper, ...props }) => {
    return <Typography
        {...props}
        className={insidePaper ? classes.padding : ""}
        variant={`h${variant}`}
        gutterBottom
    />
}

export const HeaderMd = withStyles(style)(headerMd)